import { FormatLabelFn } from '@@partner:types:app'
import {
  PRODUCT_STATUS_DISABLED,
  PRODUCT_STATUS_ENABLED,
  PRODUCT_STATUS_EXCLUDED
} from '@@partner:config/product'

export const formatProductStatusLabel: FormatLabelFn = (value) => {
  switch (value) {
  case PRODUCT_STATUS_EXCLUDED:
    return { label: 'Недоступен', color: 'red' }
  case PRODUCT_STATUS_DISABLED:
    return { label: 'Отключен до синхронизации', color: 'yellow' }
  case PRODUCT_STATUS_ENABLED:
    return { label: 'Активен', color: 'green' }
  default:
    return { label: 'Неизвестный статус', color: 'violet' }
  }
}
